import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Inject,
	Input,
	OnInit,
	Output,
} from '@angular/core';
import {
	CarrierFeedback,
	ContactsTable,
	IS_NOT_EMPTY,
	IS_NOT_NULL_OR_UNDEFINED,
	TruckSearchTable,
} from 'cargo-chief-commons';
import { TRUCK_TYPES } from '@domain/constants/truck-types';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { UtilService } from '@service/util/util.service';
import { AddContactFormDialog } from '../add-contact/add-contact.component';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
	selector: 'app-carrier-contacts-feedback',
	templateUrl: './carrier-contacts-feedback.component.html',
	styleUrls: ['./carrier-contacts-feedback.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarrierContactsFeedbackComponent implements OnInit {
	@Input() capacitySearch: TruckSearchTable = null;
	@Input() contactList: Array<ContactsTable> = null;
	@Input() searchTruckForm = null;
	@Output() customerCarrierUpdated: EventEmitter<any> = new EventEmitter();
	@Output() emitUserResponse: EventEmitter<CarrierFeedback> = new EventEmitter();
	@Output() feedbackExists: EventEmitter<boolean> = new EventEmitter();
	@Output() updateContactsList: EventEmitter<any> = new EventEmitter();

	feedbackQuestionMap = {
		reached_carrier: { order: 0, answer: null },
		// 'contact_id': { order: 1, answer: null },
		// 'booked_load': { order: 2, answer: null },
		load_not_booked_reason: { order: 2, answer: null },
		rating: { order: 3, answer: null },
		hasCapacity: { order: 4, answer: null },
		userSuggestion: { order: 5, answer: null },
	};
	loadNotBookedReasons = ['No Truck', 'Price', 'Pickup Date', 'Delivery Date'];
	isCustomerCarrierUpdated = false;
	feedbackNotGiven = true;
	IS_NOT_EMPTY = IS_NOT_EMPTY;

	constructor(
		private cargochief: Cargochief,
		public utilService: UtilService,
		public dialog: MatDialog
	) {}

	ngOnInit() {
		this.initializeCustomerResponse();
	}

	updateAnswer(question: string, answer: any): void {
		this.feedbackQuestionMap[question]['answer'] = answer;
		this.resetOtherQuestions(question);
		this.allQuestionsAnswered();
	}

	resetOtherQuestions(answeredQuestion: string) {
		Object.keys(this.feedbackQuestionMap).map((question) => {
			if (
				answeredQuestion != question &&
				this.feedbackQuestionMap[question]['order'] >
					this.feedbackQuestionMap[answeredQuestion]['order']
			) {
				this.feedbackQuestionMap[question]['answer'] = null;
			}
		});
	}

	disableButton(question: string, answer: any): boolean {
		return this.feedbackQuestionMap[question].answer === answer;
	}

	showQuestion(question: string): boolean {
		switch (question) {
			// case 'contact_id':
			// 	return this.feedbackQuestionMap['reached_carrier'].answer != null &&
			// 		this.feedbackQuestionMap['reached_carrier'].answer == true;
			case 'rating':
				return this.feedbackQuestionMap['reached_carrier'].answer != null;
			// return this.feedbackQuestionMap['contact_id'].answer != null;
			// case 'booked_load':
			// 	return this.feedbackQuestionMap['contact_id'].answer != null;
			// case 'load_not_booked_reason':
			// 	return this.feedbackQuestionMap['booked_load'].answer == false;
		}
	}

	allQuestionsAnswered() {
		if (this.feedbackQuestionMap.reached_carrier.answer == false) {
			this.feedbackQuestionMap.load_not_booked_reason.answer = 'Carrier not reached';
			this.emitUserResponse.emit(this.getFeedbackObject());
		} else if (
			this.isReachedCarrierAnswered() &&
			this.isRatingSelected() &&
			this.hasCapacityAnswered()
		) {
			this.emitUserResponse.emit(this.getFeedbackObject());
		} else {
			this.emitUserResponse.emit(null);
		}
	}

	isReachedCarrierAnswered() {
		if (IS_NOT_NULL_OR_UNDEFINED(this.feedbackQuestionMap.reached_carrier.answer)) {
			return true;
		}
		return false;
	}

	// isContactNameSelected() {
	// 	if(this.feedbackQuestionMap.contact_id.answer != null) {
	// 		return true;
	// 	}
	// 	return false;
	// }

	isRatingSelected() {
		return this.feedbackQuestionMap.rating.answer != null;
	}

	hasCapacityAnswered() {
		return IS_NOT_NULL_OR_UNDEFINED(this.feedbackQuestionMap.hasCapacity.answer);
	}

	// isBookedLoadAnswered() {
	// 	if(this.feedbackQuestionMap.booked_load.answer != null) {
	// 		return true;
	// 	}
	// 	return false;
	// }

	// isLoadNotBookedReasonSelected() {
	// 	if(this.feedbackQuestionMap.booked_load.answer === true) {
	// 		return true;
	// 	}
	// 	if(this.feedbackQuestionMap.booked_load.answer === false &&
	// 		this.feedbackQuestionMap.load_not_booked_reason.answer != null) {
	// 			return true;
	// 	}
	// 	return false;
	// }

	getFeedbackObject(): CarrierFeedback {
		const account = this.cargochief.getAccount();
		const user = this.cargochief.getUser();

		return {
			accountId: account.id,
			originCity: this.searchTruckForm.origin.city,
			originState: this.searchTruckForm.origin.state,
			destCity: this.searchTruckForm.destination.city,
			destState: this.searchTruckForm.destination.state,
			trailerTypes: this.searchTruckForm.trailerType,
			contact: {
				// id: this.feedbackQuestionMap.contact_id.answer,
				// firstName: this.getContactName(this.feedbackQuestionMap.contact_id.answer)
			},
			user: {
				id: user.id,
				firstName: user.firstName,
			},
			booked: undefined, //this.feedbackQuestionMap.booked_load.answer,
			reachedCarrier: this.feedbackQuestionMap.reached_carrier.answer,
			loadNotBookedReason: this.feedbackQuestionMap.load_not_booked_reason.answer,
			truckId: this.capacitySearch.id,
			truckType: this.capacitySearch.isLane ? TRUCK_TYPES.LANE : TRUCK_TYPES.TRUCK,
			carrierId: this.capacitySearch.carrierId,
			truckSearchId: !this.capacitySearch.isLane ? this.capacitySearch.searchId : null,
			truckLaneSearchId: this.capacitySearch.isLane ? this.capacitySearch.searchId : null,
			rating: this.feedbackQuestionMap.rating.answer,
			userSuggestion: this.feedbackQuestionMap.userSuggestion.answer,
			hasCapacity: this.feedbackQuestionMap.hasCapacity.answer,
		};
	}

	initializeCustomerResponse() {
		const feedback: CarrierFeedback = this.cargochief.getCustomerResponseByCarrierId(
			this.capacitySearch.carrierId
		);
		if (!this.utilService.isNullOrUndefined(feedback)) {
			this.feedbackQuestionMap.reached_carrier.answer = feedback.reachedCarrier;
			// this.feedbackQuestionMap.contact_id.answer = feedback.contact.id || null;
			this.feedbackQuestionMap.rating.answer = feedback.rating || null;
			// this.feedbackQuestionMap.booked_load.answer = feedback.booked;
			// this.feedbackQuestionMap.load_not_booked_reason.answer = feedback.loadNotBookedReason || null;
			this.feedbackExists.emit(true);
			this.feedbackNotGiven = false;
		}
	}

	getContactName(id: string): string {
		if (
			this.utilService.isNullOrUndefined(id) ||
			this.utilService.isNullOrUndefined(this.contactList)
		) {
			return '';
		}
		const filteredContact = this.contactList.filter((contact) => contact.contactId == id)[0];
		if (this.utilService.isNullOrUndefined(filteredContact)) {
			return '';
		}
		return filteredContact.firstName;
	}

	getActionButtonClass(question: string, selection: boolean): string {
		if (
			(question == 'hasCapacity' || question == 'feedback') &&
			!this.feedbackQuestionMap.reached_carrier
		) {
			return 'disable-text';
		}
		if (this.disableButton(question, selection)) {
			return 'font-weight-bold text-underline';
		}
	}

	openContactDialog(contact: ContactsTable) {
		const isEditContact = !this.utilService.isNullOrUndefined(contact);
		const dialogRef = this.dialog.open(AddContactFormDialog, {
			width: '500px',
			data: {
				carrierid: this.capacitySearch.carrierId,
				isEdit: isEditContact,
				contact: contact,
			},
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (!this.utilService.isNullOrUndefined(result)) {
				if (isEditContact) {
					const indexUpdated = this.contactList.findIndex((contact) => {
						return contact.contactId == result.contactId;
					});
					this.contactList[indexUpdated] = Object.assign({}, result);
				} else {
					this.contactList.unshift(result);
				}
				this.updateContactsList.emit(this.contactList);
				// this.feedbackQuestionMap['contact_id']['answer'] = result.contactId;
			}
		});
	}

	editContact() {
		const dialogRef = this.dialog.open(SelectContactDialog, {
			width: '500px',
			data: {
				contactList: this.contactList,
			},
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (!this.utilService.isNullOrUndefined(result) && result) {
				this.openContactDialog(result);
			}
		});
	}

	openFeedbackDialog() {
		const dialogRef = this.dialog.open(FeedbackDialog, {
			width: '600px',
			data: {
				feedback: this.feedbackQuestionMap.userSuggestion.answer,
			},
		});
		dialogRef.afterClosed().subscribe((result) => {
			this.feedbackQuestionMap.userSuggestion.answer = result;
			this.allQuestionsAnswered();
		});
	}
}

@Component({
	selector: 'app-select-contact',
	templateUrl: 'modal.template.html',
})
export class SelectContactDialog implements OnInit {
	selectedCarrier: ContactsTable = null;

	constructor(
		public dialogRef: MatDialogRef<SelectContactDialog>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public utilService: UtilService
	) {}

	ngOnInit() {}

	closeDialog(data: any): void {
		this.dialogRef.close(data);
	}
}

@Component({
	selector: 'app-feedback',
	templateUrl: 'feedback-modal.html',
})
export class FeedbackDialog implements OnInit {
	feedback: string = '';
	IS_NOT_EMPTY = IS_NOT_EMPTY;

	constructor(
		public dialogRef: MatDialogRef<FeedbackDialog>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public utilService: UtilService
	) {}

	ngOnInit() {
		this.feedback = this.data.feedback;
	}

	closeDialog(data: any): void {
		this.dialogRef.close(data);
	}
}
